:host {
  --rzf-card--align-text: center;
  --rzf-card--min-width: 320px;
  --rzf-card--max-width: 370px;
  --rzf-card--border: 1px solid #ddd;
  --rzf-card--border-radius: 8px;
  --rzf-card--background-color: #fff;
  --rzf-card--padding: 0 16px;

  --rzf-card__content--padding: 5px 35px 0 35px;

  --rzf-card__footer--background-color: #f9f9f9;
  --rzf-card__footer--font-size: 0.75em;
  --rzf-card__footer--color: #555;

  --rzf-card--overflow: hidden;
  --rzf-card--justify-items: start;

  display: grid;
  justify-items: center;

  min-width: var(--rzf-card--min-width);
  max-width: var(--rzf-card--max-width);
}

.rzf-card {
  border: var(--rzf-card--border);
  border-radius: var(--rzf-card--border-radius);
  background-color: var(--rzf-card--background-color);
  overflow: var(--rzf-card--overflow);
  display: grid;
  justify-items: var(--rzf-card--justify-items);

  position: relative;
}

.rzf-card > a{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  text-decoration: none;
}

::slotted([slot="image"]) {
  max-width: 100%;
  height: auto;
}

.rzf-card__content {
  padding: var(--rzf-card__content--padding);
}

.rzf-card__header {
  margin-bottom: 8px;
}

.rzf-card__footer {
  display: grid;
}
